import { Button, Flex, Input, Td, Text, Tr } from "@chakra-ui/react";

const TableRow = ({
  title,
  wattage,
  onWattageChange,
  quantity,
  onQuantityDecrement,
  onQuantityIncrement,
}) => {
  return (
    <Tr>
      <Td>
        <Text fontWeight="bold" fontSize={"14px"} textTransform={"uppercase"}>
          {title}
        </Text>
      </Td>
      <Td>
        <Input
          type="number"
          name={`${title}.wattage`}
          id={`${title}.wattage`}
          value={wattage}
          onChange={onWattageChange}
          placeholder={"0"}
          h={"40px"}
          w={"80px"}
          fontSize={"14px"}
          borderRadius={"1px"}
          bg={"#FBFBFB"}
          border={"1px solid #E0E0E0"}
        />
      </Td>
      <Td>
        <Flex alignItems="center" fontSize={"14px"}>
          <Button
            size="xs"
            onClick={onQuantityDecrement}
            borderRadius={"50%"}
            colorScheme="green"
          >
            -
          </Button>
          <Text w={"40px"} textAlign={"center"}>
            {quantity}
          </Text>
          <Button
            size="xs"
            onClick={onQuantityIncrement}
            borderRadius={"50%"}
            colorScheme="green"
          >
            +
          </Button>
        </Flex>
      </Td>
    </Tr>
  );
};

export default TableRow;
